import EventBus from '@/components/mixins/event-bus-mixin'
import UnsavedDataMixin from '@/components/mixins/unsaved-data-mixin'

export default {
  name: 'menuItem',
  inject: [
    '$currentUser',
    '$utils'
  ],
  components: {
  },
  props: {
    data: {
      default () { return 'object' }
    }
  },
  mixins: [UnsavedDataMixin],
  data () {
    return {
      menuItems: [
        {
          id: 'media',
          rounteName: 'media',
          fullPath: '/media',
          name: this.$t('label.file', 2),
          isVisible: false,
          addClass: { }
        },
        {
          id: 'create',
          rounteName: 'create',
          fullPath: '/create',
          name: this.$t('label.create'),
          isVisible: false,
          addClass: { createLock: false }
        },
        {
          id: 'schedule',
          rounteName: 'schedule',
          fullPath: '/schedule',
          name: this.$t('label.schedule'),
          isVisible: false,
          addClass: {}
        },
        {
          id: 'player',
          rounteName: 'player',
          fullPath: '/player',
          name: this.$t('label.player', 2),
          isVisible: false,
          addClass: {}
        },
        {
          id: 'alert',
          rounteName: 'alert',
          fullPath: '/alert',
          name: this.$t('label.alert', 2),
          isVisible: false,
          addClass: {}
        }
      ]
    }
  },
  methods: {
    dispatchToParentComponent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('menu-item-change', { action, payload: { data } })
      }
    },
    handleItemSelection () {
      const currentRouteName = this.$route.name
      if (typeof (this.$refs[currentRouteName]) !== 'undefined') {
        this.setItemAsSelected(currentRouteName)
      }
    },
    handlMenuItemVisibility () {
      const setItemVisibility = () => {
        const menuItems = this.$utils.clone(this.menuItems)

        for (const item of menuItems) {
          if (this.$currentUser.isStandAloneUser() || this.$currentUser.isFreeUser()) {
            item.isVisible = true
            if (item.id === 'alert') item.isVisible = false
          } else if (this.$currentUser.hasGroupUserAdmin()) {
            item.isVisible = true
          } else if (!this.$currentUser.hasGroupUserAdmin() && this.$currentUser.getUserGroupId() !== null) {
            const create = this.$currentUser.hasGroupUserCreate()
            const createLock = this.$currentUser.hasGroupUserCreateLock()
            const schedule = this.$currentUser.hasGroupUserSchedule()
            const player = this.$currentUser.hasGroupUserPlayer()
            const alert = this.$currentUser.hasGroupUserAlert()
            const modify = this.$currentUser.hasUserRightModify()

            item.isVisible = false

            if (item.id === 'create' && (create || createLock)) item.isVisible = true
            if (item.id === 'schedule' && (schedule)) item.isVisible = true
            if (item.id === 'player' && (player)) item.isVisible = true
            if (item.id === 'alert' && (alert)) item.isVisible = true
            if (item.id === 'media' && (modify || schedule)) item.isVisible = true

            // Add class to change icon
            if (item.id === 'create' && createLock) item.addClass.createLock = true
          } else if (this.$currentUser.hasGroupEnterprise()) {
            item.isVisible = true

            // Add class to change icon
            if (item.id === 'create' && this.$currentUser.hasGroupUserCreateLock()) item.addClass.createLock = true
          }

          // (global right) If there is a user_limited right, files button is visible but create button should not be visible in menu
          if (this.$currentUser.hasGroupUserLimited()) {
            if (item.id === 'create') item.isVisible = false
          }
        }
        this.menuItems = menuItems
      }

      // Listen from Global Event Bus
      EventBus.$on('SIGNED_IN', (payLoad) => { setItemVisibility() })
      EventBus.$on('SIGNED_OUT', (payLoad) => { setItemVisibility() })
      setItemVisibility()
    },
    handleMenuItemClick (itemRef, routeName, fullPath) {
      this.setItemAsSelected(itemRef)

      // Check unsaved data before redirection
      this.checkUnsavedData({
        nextAction: () => {
          /* Dispatch an action to parent component to close the menu and
           redirect if the current page is not equal to the selected menu item */
          if (typeof (routeName) !== 'undefined' && routeName !== '') {
            this.dispatchToParentComponent('MENU_ITEM_CLOSE', {})

            if (routeName === this.$route.name && fullPath === this.$router.fullPath) {
              return
            }

            this.$router.push(fullPath, () => {})
            EventBus.$emit('MENU_ITEM_CLICKED', { itemRef, routeName, fullPath })
          }
        }
      })
    },
    setItemAsSelected (itemRef) {
      $('.menu-item-row').find('.item').removeClass('is-active')
      $(this.$refs[itemRef].$el).addClass('is-active')
    }
  },
  mounted () {
    this.handleItemSelection()
    this.handlMenuItemVisibility()

    if (this.$route.name === 'menu') {
      this.setItemAsSelected('create')
    }
  }
}
